import { Injectable } from '@angular/core';
import { AudienceFilterModel } from '../data/models/audience-filter.model';

@Injectable({
  providedIn: 'root',
})
export class FilterServiceService {
  constructor() {}

  private _filters: AudienceFilterModel | null = null;

  setFilters(filters: AudienceFilterModel): void {
    this._filters = filters;
  }

  getFilters(): AudienceFilterModel | null {
    return this._filters;
  }

  clear(): void {
    this._filters = null;
  }
}
